"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var inertia_react_1 = require("@inertiajs/inertia-react");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var ziggy_js_1 = __importDefault(require("ziggy-js"));
var CreateApiTokenModal = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)(""), tokenName = _a[0], setTokenName = _a[1];
    var createApiTokenForm = (0, inertia_react_1.useForm)({
        name: "",
    });
    var createToken = function () {
        createApiTokenForm.post((0, ziggy_js_1.default)("api-tokens.store"), {
            preserveScroll: true,
            onSuccess: function () {
                props.toggle();
                createApiTokenForm.reset();
                setTokenName("");
            },
        });
    };
    var body = (react_1.default.createElement("div", { className: "d-flex flex-column" },
        react_1.default.createElement("div", { className: "mt-4" },
            react_1.default.createElement(Label_1.default, { htmlFor: "token_name" }, t("Token name")),
            react_1.default.createElement(q_play_components_1.Input, { id: "token_name", className: "mt-1 block w-full", value: tokenName, onChange: function (event) { setTokenName(event.target.value); createApiTokenForm.setData("name", event.target.value); }, required: true, "data-cy": "TokenNameInput" }))));
    var footer = (react_1.default.createElement("div", { className: "d-flex flex-fill justify-content-between", style: { marginTop: "1rem" } },
        react_1.default.createElement(q_play_components_1.Button, { onClick: createToken, variant: "primary", text: t("Create"), size: "small", className: "w-75", dataCy: "createTokenButton" })));
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: props.isShown, actionRequired: true, centered: true, onClose: props.toggle, headerText: t("Create API token"), body: body, footer: footer }));
};
exports.default = CreateApiTokenModal;
